import { Link } from "react-router";
import { Button } from "semantic-ui-react";
import ConsultMessage from "../../../NUI/ConsultMessage";

export function ErrorMessage({ status, error }) {
	if (status !== "error") {
		return null;
	}

	const cta = error?.extra?.sid ? (
		<Button
			as={Link}
			to={{ pathname: `/treatment/${error.extra.sid}` }}
			content="Go to consult"
			color="cta_tertiary"
			compact
			className="whitespace-nowrap"
		/>
	) : Array.isArray(error?.extra?.actions) && error.extra.actions.length > 0 ? (
		<>
			{error.extra.actions.includes("reload") && (
				<Button basic type="button" onClick={() => window.location.reload()}>
					Reload
				</Button>
			)}
		</>
	) : (
		false
	);

	const content = typeof error === "string" ? error : String(error?.err ?? error?.error ?? error?.message ?? error);
	const extra = error?.desc;
	const list = error?.list;

	return (
		<ConsultMessage cta={cta} header="Error submitting your request" content={content} extra={extra} list={list} />
	);
}
